import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type WishItemState = {
  popularItems: PopularItemDto[];
}

const initialState = {
  popularItems: []
} as WishItemState

export const wishItem = createSlice({
  name: "wishItem",
  initialState: initialState,
  reducers: {
    updatePopularItems: (state, action: PayloadAction<PopularItemDto[]>) => {
      state.popularItems = action.payload
    }
  }
})

export const {
  updatePopularItems
} = wishItem.actions

export default wishItem.reducer
